var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"loading":_vm.loading,"items":_vm.roles,"label":_vm.$t('users.form.role')},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }